import styled from 'styled-components'

export default styled.div`
  iframe {
    max-width: 100%;
  }
`
